import { createFileRoute } from '@tanstack/react-router';
import { EditStoreContact } from '@/features/business/components/edit/EditStoreContact';

export const Route = createFileRoute('/(app)/(store)/store/edit/contact')({
  component: RouteComponent,
});

function RouteComponent() {
  return <EditStoreContact />;
}
